<template>
  <div class="full-width pa-4">
    <div
      v-for="header in headers"
      :key="header.value"
      class="d-flex align-center pb-1"
    >
      <div
        class="py-0 text-left pr-4 flex-grow-0 flex-shrink-0 label-name"
        :style="{ width: currentWidthLabel, 'flex-basis': currentWidthLabel }"
      >
        <slot :header="header" :name="'header.' + header.value">
          <trans-field transable :value="header"></trans-field>
        </slot>
      </div>
      <div class="flex-grow-1 overflow-hidden">
        <slot
          :header="header"
          :isGrid="true"
          :item="item"
          :name="'item.' + header.value"
          :value="fetchFromObject(item, header)"
          >{{ fetchFromObject(item, header) }}</slot
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getValueRow } from '../mixins/base-table.mixins'
export default {
  props: {
    item: { type: Object, default: () => ({}), required: true },
    headers: { type: Array, default: () => [], required: true },
  },
  data: () => ({}),
  computed: {
    currentWidthLabel() {
      return '120px'
    },
  },
  methods: {
    fetchFromObject(obj, header) {
      return getValueRow(obj, header)
    },
  },
}
</script>

<style scoped></style>
